import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { useHideScrollBar } from './common'

interface ModalProps {
  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void
  children: React.ReactNode
}

const ModalBox: React.FC<ModalProps> = ({ isModalOpen, setIsModalOpen, children }) => {
  useHideScrollBar(isModalOpen)

  // Initialize screenWidth with the current window width
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth)

  // Update screenWidth on window resize
  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => setScreenWidth(window.innerWidth)

    // Add event listener
    window.addEventListener('resize', handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (isModalOpen === true) {
    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}>
          <motion.div
            className="fixed z-[1000] inset-0 overflow-auto mx-5 md:mx-0 bg-blue-100 bg-opacity-20"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}>
            <motion.div
              className="flex items-center justify-center min-h-screen"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}>
              <div
                onClick={() => setIsModalOpen(!isModalOpen)}
                className="fixed inset-0 bg-[#1E1E1E] bg-opacity-50 transition-opacity"
                aria-hidden="true"></div>
              <motion.div
                className="relative bg-primary dark:bg-base-100 rounded-[8px] shadow-xl transform transition-all w-full sm:w-fit bg-white flex flex-wrap h-full"
                initial={{ opacity: 0, scale: 0.1 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.1 }}
                style={
                  screenWidth > 600
                    ? {
                        background:
                          'linear-gradient(125deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.90) 0.01%, rgba(255, 255, 255, 0.10) 99.52%)',
                        boxShadow: '0px 20px 40px 0px rgba(0, 0, 0, 0.05)',
                        border: '2px solid rgba(255, 255, 255, 0.60)',
                        backdropFilter: 'blur(20px)'
                      }
                    : {}
                }>
                {children}
              </motion.div>
            </motion.div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    )
  }

  return null
}

export default ModalBox
